export const TOGGY_BANNER_SESSION_KEY = 'toggy-moderate-banner-dismissed:strip'
export const TOGGY_PAGE_BANNER_SESSION_KEY =
  'toggy-moderate-banner-dismissed:page'
/** Strip height in px. Only numeric source — CSS and the trial overlay read this. */
export const TOGGY_BANNER_HEIGHT_PX = 48
export const TOGGY_BANNER_HEIGHT = `${TOGGY_BANNER_HEIGHT_PX}px`
export const TOGGY_BANNER_HEIGHT_VAR = '--toggy-banner-height'
export const TOGGY_BANNER_HREF = 'https://toggy.ai'

const isDismissed = (key: string): boolean => {
  try {
    return sessionStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

const dismiss = (key: string): void => {
  try {
    sessionStorage.setItem(key, '1')
  } catch {
    // Private mode / storage disabled — fail silently.
  }
}

export const isToggyBannerDismissed = (): boolean =>
  isDismissed(TOGGY_BANNER_SESSION_KEY)

export const dismissToggyBanner = (): void => dismiss(TOGGY_BANNER_SESSION_KEY)

export const isToggyPageBannerDismissed = (): boolean =>
  isDismissed(TOGGY_PAGE_BANNER_SESSION_KEY)

export const dismissToggyPageBanner = (): void =>
  dismiss(TOGGY_PAGE_BANNER_SESSION_KEY)

export const toggyBannerHeightRootCss = (): string =>
  `:root { ${TOGGY_BANNER_HEIGHT_VAR}: ${TOGGY_BANNER_HEIGHT}; }`
